(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionController', InterventionController);

    InterventionController.$inject = ['$state', 'Intervention', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InterventionController($state, Intervention, Technicien,ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicienEquipe').select2();
        });
        $('#filterTechnicien').on('select2:select', function (e) {
            vm.search();
        });
        $('#filterTechnicienEquipe').on('select2:select', function (e) {
            vm.search();
        });
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        if(typeof pagingParams.status =='string'){
        	vm.filterStatus = [pagingParams.status];
        }else{
        	vm.filterStatus = pagingParams.status;
        }
        if(typeof pagingParams.comparaisonStatus =='string'){
        	vm.filterComparaisonStatus = [pagingParams.comparaisonStatus];
        }else{
        	vm.filterComparaisonStatus = pagingParams.comparaisonStatus;
        }
        vm.filterSearch = pagingParams.search;
        vm.filterDateFrom = pagingParams.dateFrom;
        vm.filterDateTo = pagingParams.dateTo;
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterTechnicienEquipe = pagingParams.technicienEquipe;
        vm.filterTailleEquipe = pagingParams.tailleEquipe;
        vm.filterTechnicienRole = pagingParams.technicienRole;
        vm.filterConstructelFilename = pagingParams.constructelFilename;
        vm.filterDateMailImport = pagingParams.dateMailImport;
        vm.filterFilename = pagingParams.filename;
        vm.filterBonDeCommande = pagingParams.bonDeCommande;
        vm.excludeBonDeCommande = pagingParams.excludeBonDeCommande === true || pagingParams.excludeBonDeCommande === 'true';
        vm.displayReo=true;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.manualClose = manualClose;
        vm.facturationFight = facturationFight;
        vm.resetBonusMalus = resetBonusMalus;
        vm.resetBonusMalusIntervention = resetBonusMalusIntervention;
        vm.getTotalPrice = getTotalPrice;
        vm.selectPhoneNumber = selectPhoneNumber;
        vm.getBonDeCommandeComment = getBonDeCommandeComment;

        loadAll();
        loadTechniciens();

        function loadAll () {
            Intervention.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search: vm.filterSearch,
                status: vm.filterStatus,
                comparaisonStatus: vm.filterComparaisonStatus,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                technicienEquipe: vm.filterTechnicienEquipe,
                tailleEquipe: vm.filterTailleEquipe,
				technicienRole: vm.filterTechnicienRole,
                constructelFilename: vm.filterConstructelFilename,
                dateMailImport: vm.filterDateMailImport,
                filename: vm.filterFilename,
                bonDeCommande: vm.filterBonDeCommande,
                excludeBonDeCommande: vm.excludeBonDeCommande
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                result.push('defaultSort,asc');
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.interventions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTechniciens(){
        	Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search(){
        	vm.transition();
        }

        function transition() {
            var params = createInterventionFilter();
            params.page = vm.page;
            params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            $state.transitionTo($state.$current, params);
        }

		function createInterventionFilter(){
			return {
                search: vm.filterSearch,
                status: vm.filterStatus,
                comparaisonStatus: vm.filterComparaisonStatus,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: $('#filterTechnicien').val(),
                technicienEquipe: $('#filterTechnicienEquipe').val(),
				technicienRole: $('#filterTechnicienRole').val(),
                tailleEquipe: vm.filterTailleEquipe,
                constructelFilename: vm.filterConstructelFilename,
                dateMailImport: vm.filterDateMailImport,
                filename: vm.filterFilename,
                bonDeCommande: vm.filterBonDeCommande,
                excludeBonDeCommande: vm.excludeBonDeCommande
            }
		}

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function manualClose(id){
        	Intervention.manualClose({id:id},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function facturationFight(id) {
            Intervention.facturationFight({id:id},function(s){
                loadAll();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function getTotalPrice(){
        	var totalPrice=0;
        	if(vm.interventions){
        		vm.interventions.forEach(function(intervention) {
        			if(intervention.price){
        				totalPrice+=intervention.price;
        			}
        		});
        	}
        	return totalPrice;
        }

        function selectPhoneNumber(phoneNumber){
        	vm.filterSearch=phoneNumber;
        	vm.filterStatus=null;
        	vm.filterComparaisonStatus=null;
        	search();
        }

        vm.reset = function(){
            vm.excludeBonDeCommande = false;
        	 $state.transitionTo($state.$current, {
                 page: vm.page,
                 sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                 search: vm.filterSearch
             });
        }

        vm.getCssClass=function(intervention){
        	var cssClass='';
        	if(intervention.reo){
        		cssClass+=' warning';
        	}else{
        		for (var i = 0; i < intervention.activities.length; i++) {
        			var activitie=intervention.activities[i];
//        			if(activitie.code.indexOf('BONUS')>0){
//                		cssClass+=' success';
//        			}
        		}
        	}
        	return cssClass;
        }

        function resetBonusMalus(){
        	Intervention.bonusMalus(createInterventionFilter(),function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function resetBonusMalusIntervention(){
        	var interventionId=vm.interventions[vm.interventions.length-1].id;
        	Intervention.bonusMalusIntervention({id:interventionId},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        vm.arround = function(i) {
            return Math.ceil(i);
        }

        function getBonDeCommandeComment(intervention, bonDeCommande) {
            if (!intervention || !intervention.listCommentary || !intervention.listCommentary.length) {
                return null;
            }
            var needle = "Bon de commande " + bonDeCommande;

            for (var i = intervention.listCommentary.length - 1; i >= 0; i--) {
                var text = intervention.listCommentary[i];
                if (text && text.indexOf(needle) !== -1) {
                    var dotIdx = text.lastIndexOf(". ");
                    if (dotIdx !== -1 && dotIdx + 2 < text.length) {
                        var userComment = text.substring(dotIdx + 2).trim();
                        return userComment.length ? userComment : null;
                    }
                    return text;
                }
            }
            return null;
        }
    }
})();
